import { useMemo } from "react";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts/core";
import * as S from "./LineChart.style";

interface LineChartProps {
  chartData: { result: { xData: any; yData: [number, number][] }; YUnit: any };
}

export const LineChart = ({ chartData }: LineChartProps) => {
  const processedData = chartData.result.yData.map(([yValue]) => yValue);

  // 이상값(특정 색상으로 표시할 데이터) 처리
  const outlierData = chartData.result.yData.map(
    ([yValue, colorIndicator], index) => ({
      value: [chartData.result.xData[index], yValue], // x, y 좌표
      itemStyle: {
        color:
          colorIndicator === 1
            ? "orange"
            : colorIndicator === 2
            ? "red"
            : undefined, // colorIndicator에 따라 색상 지정
      },
    })
  );

  const options = useMemo(
    () => ({
      tooltip: {
        trigger: "axis",
        responsive: true,
        position: "bottom",
      },
      xAxis: [
        {
          type: "category",
          data: chartData?.result.xData,
        },
      ],
      grid: {
        containLabel: true,
        left: 10,
        top: 25,
        right: 10,
        bottom: 0,
      },
      yAxis: {
        type: "value",
        splitLine: {
          lineStyle: {
            type: "dashed",
          },
        },
        name: `단위: ${chartData?.YUnit}`,
        nameLocation: "end",
        nameRotate: 0,
        nameGap: 10,
        position: "left",
        nameTextStyle: {
          padding: [20, 0, 0, 30],
        },
      },
      series: [
        {
          name: "센서 값",
          data: processedData, // 라인 그래프 데이터
          type: "line",
          smooth: true,
          symbol: "none", // 점을 제거하여 `scatter` 시리즈에만 표시되도록
        },
        {
          name: "이상값",
          data: outlierData.filter((point) => point.itemStyle.color), // 이상값만 필터링하여 표시
          type: "scatter",
          symbol: "circle",
          symbolSize: 8,
          z: 3,
        },
      ],
    }),
    [chartData?.result]
  );

  return (
    <S.LineChartBox>
      <ReactECharts
        echarts={echarts}
        option={options}
        opts={{ renderer: "svg" }}
        style={{ width: "100%", height: "100%", margin: "0 auto" }}
      />
    </S.LineChartBox>
  );
};
